import 'bootstrap/dist/js/bootstrap'

document.addEventListener("turbolinks:load", () => {
  $('[data-toggle="popover"]').popover({ trigger: 'focus' })
  $('[data-toggle="tooltip"]').tooltip()
})
